<template>
	<div class="page-wrap" v-bind:class="{'colour-tint' : screenId === '1'}">
		<LandingScreen :bgImg="bgImg" :screenId="screenId"></LandingScreen>
    	<HomeScreenInfo></HomeScreenInfo>
		<HomeCategories></HomeCategories>
    	<div class="anim-leave"></div> 
	</div>
</template>

<script>  
import LandingScreen from '@/components/LandingScreen.vue'
import HomeScreenInfo from '@/components/HomeScreenInfo.vue'
import HomeCategories from '@/components/HomeCategories.vue'

export default {
  name: 'home',
  components: {
    LandingScreen,
    HomeScreenInfo,
    HomeCategories
  },

  data () {
    return {
     bgImg: null,
     screenId: null
    }
  },

  created () {
      this.screenId = this.$router.currentRoute.params.screenId
      this.bgImg = require('../assets/img/images/landing/landing-screen-' + this.screenId + '.jpg')
    },
    beforeRouteUpdate () {
      this.screenId = this.$router.currentRoute.params.screenId
      this.bgImg = require('../assets/img/images/landing/landing-screen-' + this.screenId + '.jpg')
    }
}
</script>